import { ref } from 'vue'
import { useHttp } from '@/composables/http/useHttp.js'
import { useStore } from '@/composables/store/useStore.js'

export function useRequest () {
  const store = useStore()
  const request = ref({ status: 0, error: null, data: null, validate: null, tipo: '' })
  const { fnAxios, fnAxiosToken, fnAxiosTokenCustomer, fnAxiosTokenDownload, fnAxiosTokenDownloadContentsFile, fnAxiosTokenDownloadContents, fnAxiosFile, fnAxiosFileCustomer } = useHttp()

  const fnHttpToken = (metodo, ruta, data, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosToken(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, request, loading)
  }

  const fnHttpTokenCustomer = (metodo, ruta, data, objecto, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosTokenCustomer(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, objecto, loading, request)
  }

  const fnHttpTokenDownload = (metodo, ruta, data, filename, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosTokenDownload(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, loading, filename, request)
  }

  const fnHttpTokenDownloadContent = (metodo, ruta, data, objecto, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosTokenDownloadContents(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, objecto, loading, request)
  }

  const fnHttpTokenDownloadContentFile = (metodo, ruta, data, objecto, loading, isPrefix, pNameFile) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosTokenDownloadContentsFile(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, objecto, loading, request, pNameFile)
  }

  const fnHttpFile = (metodo, ruta, data, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosFile(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, request, loading)
  }

  const fnHttpFileCustomer = (metodo, ruta, data, objecto, loading, isPrefix) => {
    const preFix = ((isPrefix === 1) ? store.getPrefix : '')
    fnAxiosFileCustomer(metodo, store.getUrlApi + preFix + ruta, store.getToken.text, data, objecto, loading, request)
  }

  const fnHttp = (metodo, ruta, data, loading) => {
    fnAxios(metodo, store.getUrlApi + ruta, data, request, loading)
  }

  const fnInicializarRequest = () => {
    request.value.status = 0
    request.value.error = null
    request.value.data = null
    request.value.validate = null
  }

  return { fnHttp, fnHttpToken, fnHttpTokenCustomer, fnHttpFile, fnHttpTokenDownloadContentFile, fnInicializarRequest, fnHttpTokenDownload, fnHttpTokenDownloadContent, fnHttpFileCustomer, request }
}
